import UserPersistence from "@/persistence/UserPersistence";
export const moduleId = 'loan-task';

export const state = {
    tabsName: 'agent-task',
    tabsName1:'agent-task',
    status: 1,
    agentTaskPages: "",
    overrulePages: "",
    delegatedTasks: 0
}
export const mutations = {
    setTabsName(state, name) {
        state.tabsName = name
    },
    setTabsName1(state, name) {
        state.tabsName1 = name
    },
    setStatus(state, data) {
        state.status = data
    },
    setAgentTaskPages(state, count) {
        if (count || count === 0) {
            state.agentTaskPages = count
        } else {
            state.agentTaskPages = state.agentTaskPages + 1
        }

    },
    setDelegatedTasks(state, count) {
        if (count!=null) {
            state.delegatedTasks = count
        } else {
            state.delegatedTasks = state.delegatedTasks + 1
        }
    },
    setOverrule(state, count) {
        state.overrulePages = count
    }
}
export const actions = {}

export const getters = {
    agentTaskPagesGetter(state) {
        return state.agentTaskPages
    },
    overrulePagesGetter(state) {

        return state.overrulePages
    },
    delegatedTasksGetter(state) {
        return state.delegatedTasks
    },
}


// WEBPACK FOOTER //
// ./src/store/modules/billing-center/loan-task/index.js